import moment from "moment";
import { FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { DogBaseSearch, DogHistoryActionGridDto, DogHistoryApi } from "../../../../api";
import { CustomDataTable, ExportButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IDogHistoryTabProps {
  dogId: number;
}

export const DogHistoryTab: React.FunctionComponent<IDogHistoryTabProps> = ({ dogId }) => {
  const api = useApiService(DogHistoryApi);
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const [sObjState, setsobjState] = React.useState<any>();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { actionTime: "DESC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: DogBaseSearch) => {
      setsobjState(DogBaseSearch.fromJS({ ...sObj, dogId: dogId, languageId: currentLanguage.languageId }));
      return api.baseSearch(DogBaseSearch.fromJS({ ...sObj, dogId: dogId, languageId: currentLanguage.languageId }));
    },
    [api, currentLanguage.languageId, dogId]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.When),
        fieldName: "actionTime",
        render: (row: DogHistoryActionGridDto) => moment(row.actionTime).format("DD/MM/YYYY HH:mm"),
      },
      {
        header: () => t(ETLCodes.What),
        fieldName: "action",
      },
    ],
    [t]
  );

  return (
    <FieldSet
      title={t(ETLCodes.History)}
      rightElement={<ExportButton exportFunction={(sObj) => api.exportXlsFile(sObj)} sObj={sObjState} />}
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
